/**
 * Cdn Admin Name Formatter.
 * @param {string} value
 * @param {Object} row
 * @returns {string}
 */
window.cdnAdminNameFormatter = function(value, row) {
    if (!value) return '';
    if (row.original_type === 'directory') {
        return '<a href="javascript:void(0)" class="cdn-dir-link" data-uuid="' + row.uuid + '" data-name="' + value + '">' + value + '</a>';
    }
    return value;
};
